import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Input } from '@angular/core';
import { RoleAuthService } from "../services";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: "root"
})

// This RouteGuard can be used if we need a user to be authenticated and do not need authorization.
export class AuthorizationRoleGuard implements CanActivate {
  @Input() unauthorizedUrl: string = "/unauthorized";

  constructor(private router: Router, private authService: RoleAuthService) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot ) :| Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // Next.data is the role to check for and it is passed from the app-routing module for each page.
    // If the user has this role on the OAuth Token, allow access:
    let authorizedRoles = next.data["authorizedRoles"];

    return this.authService.userHasRoleOnToken(authorizedRoles).pipe(map(authorized => {
      if(!authorized)
      {
        this.router.navigate([this.unauthorizedUrl]);
      }
      return true;
    }));
  }

  canLoad(): Observable<boolean> | Promise<boolean> | boolean {
    return this.authService.isAuthenticated().pipe(map(authorized => {
      return authorized;
    }));
  }
}
